<template>
  
</template>

<script>
  export default {
    name: "DynamicStyleMixin",
    computed: {
      styleObject: function () {
        // Please override.
        // Should return KoreyomoTopWorkItem or KoreyomoWorkInfo.
        return null
      },
      backgroundStyle: function () {
        if (this.styleObject == null || this.styleObject.backgroundColor == null) {
          return {}
        }
        return {
          'background-color': this.styleObject.backgroundColor,
        }
      },
      textStyle: function () {
        if (this.styleObject == null || this.styleObject.textColor == null) {
          return {}
        }
        return {
          'color': this.styleObject.textColor,
        }
      },
      darkBackgroundStyle: function () {
        if (this.styleObject == null || this.styleObject.visitedColor == null) {
          return {}
        }
        return {
          'background-color': this.styleObject.visitedColor,
        }
      },
      buttonStyle: function () {
        if (this.styleObject == null || this.styleObject.buttonColor == null || this.styleObject.textColor == null) {
          return {}
        }
        return {
          'background-color': this.styleObject.buttonColor,
          'color': this.styleObject.textColor,
        }
      },
      borderStyle: function () {
        if (this.styleObject == null || this.styleObject.buttonColor == null) {
          return {}
        }
        return {
          'border': this.styleObject.buttonColor + ' 2px solid'
        }
      },
      recommendViewer: function(){
        return {
          'background-color': this.recommendButton,
          'color': this.recommendTextcolor,
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/DynamicStyleMixin.vue